/**
 * Calculate age from a date of birth string.
 * Parses the YYYY-MM-DD portion directly to avoid timezone issues
 * (new Date('YYYY-MM-DD') parses as UTC, but local getters can shift the day).
 *
 * `fromDate` is injectable for deterministic tests; defaults to "now".
 */
export function calculateAge(
  dob: string | null | undefined,
  fromDate: Date = new Date()
): number | null {
  if (!dob || dob.length < 10) {
    return null;
  }

  const dateOnly = dob.slice(0, 10);
  const [yearStr, monthStr, dayStr] = dateOnly.split('-');
  const birthYear = Number(yearStr);
  const birthMonth = Number(monthStr);
  const birthDay = Number(dayStr);

  if (!Number.isFinite(birthYear) || !Number.isFinite(birthMonth) || !Number.isFinite(birthDay)) {
    return null;
  }

  let age = fromDate.getFullYear() - birthYear;
  const monthDiff = (fromDate.getMonth() + 1) - birthMonth;

  if (monthDiff < 0 || (monthDiff === 0 && fromDate.getDate() < birthDay)) {
    age--;
  }

  return age;
}
